export default __webpack_public_path__ + "static/media/logoM.311b091a.png";